import { Component, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { StripeSavedCardComponentDef } from '@df/module-stripe/stripe-saved-card.component.def';
@Component({
    selector: 'stripe-saved-card',
    templateUrl: './stripe-saved-card.html',
    styleUrls: ['./stripe-card.scss'],
    standalone: true,
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class StripeSavedCardComponent extends StripeSavedCardComponentDef implements OnInit {}
